import { ReduxState } from 'app/redux/types';

export const selectUnreadNotificationsCount = (state: ReduxState) => (
  state.notifications.unreadNotificationsCount
);
